import { render } from "./HeroiconsOutlineTranslate.vue?vue&type=template&id=751a6296"
const script = {}

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTranslate.vue"]])

export default __exports__